export const OverpayLoanSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            width="27"
            height="25"
            viewBox="0 0 27 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M8.27344 10.4185L3.73853 10.4185"
                stroke="#FB5950"
                strokeWidth="1.54839"
                strokeLinecap="round"
            />
            <path
                d="M7.86328 5.96875H0.772871"
                stroke="#FB5950"
                strokeWidth="1.54839"
                strokeLinecap="round"
            />
            <path
                d="M23.4023 0.774414H13.7572L11.9023 12.2744H15.983L14.1282 23.7744L25.2572 8.9357H20.0636L23.4023 0.774414Z"
                stroke="#08172B"
                strokeWidth="1.54839"
                strokeLinejoin="round"
            />
        </svg>
    );
};
